import { createSlice } from "@reduxjs/toolkit";
import { forgotPassword, forgotPasswordNewPass } from "./thunk";

export const initialState = {
  // POST FORGOT_PASSWORD
  forgotPasswordData: [],
  forgotPasswordError: {},
  // POST FORGOT_PASSWORD_NEW_PASS
  forgotPasswordNewPassData: [],
  forgotPasswordNewPassError: {},
};

const forgotPasswordSlice = createSlice({
  name: "forgotPasswordSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // forgot Password
    builder.addCase(forgotPassword.fulfilled, (state: any, action: any) => {
      state.forgotPasswordData = action.payload;
    });

    // forgot Password error handling
    builder.addCase(forgotPassword.rejected, (state: any, action: any) => {
      state.forgotPasswordError = action.error.message;
    });

    // forgot Password new pass
    builder.addCase(
      forgotPasswordNewPass.fulfilled,
      (state: any, action: any) => {
        state.forgotPasswordNewPassData = action.payload;
      },
    );

    // forgot Password new pass error handling
    builder.addCase(
      forgotPasswordNewPass.rejected,
      (state: any, action: any) => {
        state.forgotPasswordNewPassError = action.error.message;
      },
    );
  },
});

export default forgotPasswordSlice.reducer;
